import { RocketAPI } from '@portal/rocket-api-client';
import { createFileRoute } from '@tanstack/react-router';

import BillingEditPlanOrderConfirmation from 'component/view/Settings/BillingEditPlanOrderConfirmation';

import { requireOperation } from './-guards';

export const Route = createFileRoute(
  '/n/_auth/settings/_layout/billing/edit-plan/order-confirmation/$orderId'
)({
  beforeLoad: requireOperation({
    options: () => RocketAPI.account.getUpdateAccountHostingPlanMutationOptions(),
    redirectTo: '/n/settings/account-and-security',
  }),
  component: BillingEditPlanOrderConfirmation,
});
